import { useContext, useState, Fragment } from 'react';
import DOMPurify from "dompurify";
import IconButton from '@mui/material/IconButton';
import { icons } from "@/components/dashboard/layout/nav-icons";
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import Typography from '@mui/material/Typography';

const isMobile = window.innerWidth <= 768;
const maxWidth_tooltip = isMobile ? '20rem' : '50rem';
const maxHeight_tooltip = isMobile ? '15rem' : '25rem';
const placement_tooltip = isMobile ? 'top' : 'right-start';

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: 'var(--mui-palette-background-paper)',
        color: 'text.primary',
        maxWidth: maxWidth_tooltip,
        maxHeight: maxHeight_tooltip,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
        overflowY: 'scroll'
    },
}));
  

export function InfoTooltip({content}) {
    const InfoIcon = icons['info'];

    // can use these to test diff formatting
    const test = "<b>Tooltip with HTML</b><br/><em>And here's</em><b> some </b><u>amazing content</u>. It's very engaging. Right?"

    const siteSummary_title =  "<b>Predicted Daily Natural Gas Consumption:</b><br/>The <em>predicted daily natural gas consumption</em> is an algorithm crafted for building operators and owners, this cutting-edge solution provides a window into the expected natural gas consumption, marrying short-term building performance with upcoming weather forecasts.<br/><br/>The algorithm draws insights from the <b>past seven days of actual performance and weather data</b>, seamlessly integrating with our robust weather module. With each day's forecast, the algorithm anticipates the natural gas consumption you can expect, offering a strategic advantage in <u>proactive decision-making</u>.<br/><br/>Embrace a <em>smarter, more efficient energy future</em> with our Predicted Daily Natural Gas Consumption algorithm."

    const siteSummary =  "The <b>predicted daily natural gas consumption</b> is an algorithm crafted for building operators and owners, this <em>cutting-edge solution</em> provides a window into the expected natural gas consumption, marrying short-term building performance with upcoming weather forecasts.<br/><br/>The algorithm draws insights from the <b>past seven days of actual performance and weather data</b>, seamlessly integrating with our robust weather module. With each day's forecast, the algorithm anticipates the natural gas consumption you can expect, offering a strategic advantage in <u>proactive decision-making</u>.<br/><br/>Embrace a <em>smarter, more efficient energy future</em> with our Predicted Daily Natural Gas Consumption algorithm."
    return (
        <HtmlTooltip 
            // placement={placement_tooltip}
            arrow={true}
            enterDelay={0} 
            enterTouchDelay={0} 
            leaveTouchDelay={30000} // how long to wait before hiding tooltip on mobile
            // disableTouchListener
            // placement={{ xs: "top", lg: "right-start"}}
            sx={{margin: 0, verticalAlign: 'middle'}}
            title={
                <Fragment>
                    <Typography 
                        color='text.primary' 
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(content),
                        }}
                    />
                </Fragment>
            } 
        >
        {/* <Tooltip title={content} enterDelay={0} enterTouchDelay={0} sx={{alignmentBaseline: 'bottom', }}> */}
        {/* <Tooltip title={content} enterDelay={0} enterTouchDelay={0} > */}
            <IconButton color='inherit'>
                <InfoIcon />
            </IconButton>
        </HtmlTooltip>
    );

}